module.exports = __webpack_public_path__ + "static/img/休眠.462a513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/中巴/休眠.png
// module id = jpun
// module chunks = 76